/**
 * Machine-format date tokens (URL params, query keys, file names) in the
 * viewer's local timezone. Not display formats.
 */

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** Local calendar day key, "2026-08-31". */
export function toLocalDayKey(input: Date | string): string {
  const d = input instanceof Date ? input : new Date(input);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Local date-time token to the minute, "2026-08-31T09:05". */
export function toLocalDateTimeToken(d: Date): string {
  return `${toLocalDayKey(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Local year-month key, "2026-08". */
export function toYearMonthKey(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
}
